export default {
  segment_tabs: {
    placeholder: 'Search',
  },

  native_custom_selector: {
    placeholder: 'Search',
    no_data: 'No Data Available.',
  },

  modal: {
    close: 'Close',
    confirm: 'Confirm',
    cancel: 'Cancel',

    report: {
      warning: {
        title: 'Confirm',
        desc: 'Want to download the latest Report?',
      },
    },
  },

  button: {
    search: {
      placeholder: 'Search',
    },
  },

  pagination: {
    of: 'of',
    list: 'list',
    page: 'Page',
    go_to: 'Go To',
  },

  filter_table: {
    title: 'Filter',
    topic_sorting: 'Sorting by:',
    topic_filter: 'Filter By',
    column: 'Column:',
    all_item: 'All:',
    topic_preview: 'All Filter (Preview)',
    button_apply: 'Apply',
    button_clear: 'Clear',
    components: {
      select_operator: {
        empty: 'No data found',
      },
      select_column: {
        empty: 'No data found',
      },
      ordering: {
        asc: 'Ascending',
        desc: 'Descending',
      },
      preview_filter: {
        no_filter: 'No Filter',
      },
    },
  },
};
